import { render, staticRenderFns } from "./BaseGroupPicker.vue?vue&type=template&id=5c5b769a&scoped=true&"
import script from "./BaseGroupPicker.vue?vue&type=script&lang=js&"
export * from "./BaseGroupPicker.vue?vue&type=script&lang=js&"
import style0 from "./BaseGroupPicker.vue?vue&type=style&index=0&id=5c5b769a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5b769a",
  null
  
)

export default component.exports